<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-2">
        A gardener bought a package containing 3 squash seeds and 3 bean seeds. If just one seed is
        selected from the package what are the chances that it is a bean seed?
      </p>
      <p class="mb-4">
        <v-radio-group v-model="inputs.input1" :disabled="!allowEditing" class="mb-0 ml-3">
          <v-radio
            v-for="option in options1"
            :key="option.value"
            :value="option.value"
            class="my-3"
          >
            <template #label>
              <stemble-latex :content="option.text" />
            </template>
          </v-radio>
        </v-radio-group>
      </p>

      <h3><u>Reason</u></h3>
      <p class="mb-2">
        <v-radio-group v-model="inputs.input2" :disabled="!allowEditing" class="mb-0 ml-3">
          <v-radio
            v-for="option in options2"
            :key="option.value"
            :value="option.value"
            class="my-3"
          >
            <template #label>
              <stemble-latex :content="option.text" />
            </template>
          </v-radio>
        </v-radio-group>
      </p>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '../StembleLatex.vue';

export default {
  name: 'UPEIToTLItem5',
  components: {
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        input1: null,
        input2: null,
      },
      options1: [
        {text: '1 out of 2', value: 'a'},
        {text: '1 out of 3', value: 'b'},
        {text: '1 out of 4', value: 'c'},
        {text: '1 out of 6', value: 'd'},
        {text: '4 out 6', value: 'e'},
      ],
      options2: [
        {
          text: 'Four selections are needed because the three squash seeds could have been chosen in a row.',
          value: 'one',
        },
        {text: 'There are six seeds from which one bean seed must be chosen.', value: 'two'},
        {
          text: 'One bean seed needs to be selected from a total of three.',
          value: 'three',
        },
        {
          text: 'One half of the seeds are bean seeds.',
          value: 'four',
        },
        {
          text: 'In addition to a bean seed, three squash seeds could be selected from a total of six.',
          value: 'five',
        },
      ],
    };
  },
};
</script>
<style scoped></style>
